import {
  Users,
  UsersRound,
  BarChart3,
  Settings,
  Kanban,
  Wallet,
  Coins,
  UserCog,
  Tag,
  SlidersHorizontal,
  Megaphone,
  Sparkles,
  Bot,
  Rocket,
} from 'lucide-react';
import { usePipelineConfig } from '@/hooks/use-pipeline-config';
import { type NavItem } from './sidebar-link';

export type NavGroup = { items: NavItem[] };

function creatorsItem(isAdmin: boolean): NavItem {
  return {
    to: '/creators',
    label: isAdmin ? 'Creadores' : 'Mis creadores',
    icon: <Users size={16} />,
  };
}

const SHOWCASE_ITEMS: NavItem[] = [
  {
    to: '/founders',
    label: 'Pioneros Fundadores',
    icon: <Sparkles size={16} />,
  },
  { to: '/prepioneers', label: 'Prepioneros', icon: <Rocket size={16} /> },
];

const PROGRESS_ITEM: NavItem = {
  to: '/progress',
  label: 'Progreso',
  icon: <BarChart3 size={16} />,
  hideForApproacher: true,
};

const ADMIN_CHILDREN: NavItem[] = [
  { to: '/admin/team', label: 'Equipo', icon: <UserCog size={14} /> },
  { to: '/admin/pricing', label: 'Precios', icon: <Tag size={14} /> },
  {
    to: '/admin/communications',
    label: 'Comunicados',
    icon: <Megaphone size={14} />,
  },
  {
    to: '/admin/ai/appeals',
    label: 'Apelaciones IA',
    icon: <Bot size={14} />,
  },
  {
    to: '/admin/settings',
    label: 'Configuración',
    icon: <SlidersHorizontal size={14} />,
  },
];

const BOTTOM: NavItem[] = [
  { to: '/team', label: 'Equipo', icon: <UsersRound size={16} /> },
  {
    to: '/earnings',
    label: 'Ganancias',
    icon: <Coins size={16} />,
    hideForApproacher: true,
  },
  {
    to: '/payments',
    label: 'Pagos',
    icon: <Wallet size={16} />,
    adminOnly: true,
  },
  {
    to: '/admin',
    label: 'Admin',
    icon: <Settings size={16} />,
    adminOnly: true,
    children: ADMIN_CHILDREN,
  },
];

export function useNavGroups(isAdmin: boolean): NavGroup[] {
  const { enabled, isLoading } = usePipelineConfig();
  const pd = !isAdmin && (isLoading || !enabled);
  const main: NavItem[] = [
    ...SHOWCASE_ITEMS,
    creatorsItem(isAdmin),
    PROGRESS_ITEM,
    {
      to: '/pipeline',
      label: 'Pipeline',
      icon: <Kanban size={16} />,
      hideForCollector: true,
      disabled: pd,
    },
  ];
  return [{ items: main }, { items: BOTTOM }];
}
